

























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/infrastructure/api/adjustment/adjustmentApi';
import moment from 'moment';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import { progress } from '@/script/progress';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';
import {在庫調整検索依頼型, 在庫調整検索結果型, 在庫調整型, 在庫調整登録依頼型, to在庫調整依頼内容型} from '@/type/adjustment/records/register/在庫調整登録';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import RegisterAdjustmentDataRow from '@/views/adjustment/fragments/RegisterAdjustmentDataRow.vue';

@Component({
  components: {
    ToggleButtonField,
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    SenderSelector,
    DepartmentSelector,
    RegisterAdjustmentDataRow,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    数値フォーマット(value: number): string {
      if (value === null) {
        return '';
      }
      return value.toFixed(3);
    },
  },
})
export default class RegisterAdjustment extends Vue {
  // data
  検索条件: 在庫調整検索依頼型 = {...this.デフォルトの検索条件};
  検索結果に対応する検索条件: 在庫調整検索依頼型 | null = null;
  検索結果: 在庫調整型[] = [];
  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;
  // computed

  get 表示件数(): number {
    return this.検索結果.length;
  }

  get デフォルトの検索条件(): 在庫調整検索依頼型 {
    return {
      採用品管理対象外のみ: false,
    };
  }

  @Watch('修正対象', {deep: true})
  リストが変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  async 編集を破棄して検索を実行するハンドラ() {
    this.$modal.hide('編集中検索確認ダイアログ');
    await progress(this.検索処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  クリアダイアログを開く(): void {
    this.$modal.show('クリアダイアログ');
  }

  クリアダイアログを閉じる(): void {
    this.$modal.hide('クリアダイアログ');
  }

  確定ダイアログを開く(): void {
    this.$modal.show('確定ダイアログ');
  }

  確定ダイアログを閉じる(): void {
    this.$modal.hide('確定ダイアログ');
  }

  クリアメッセージ(): string {
    return 'クリアしますか？';
  }

  async クリア確認する() {
    await this.クリアする()
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  async クリアする(): Promise<void> {
    this.検索条件 = {...this.デフォルトの検索条件};
    this.検索結果に対応する検索条件 = null;
    this.検索結果 = [];

    this.選択行番号 = null;
    this.アラートメッセージ = null;
    this.クリアダイアログを閉じる();
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  全解除する(): void {
    for (const レコード of this.検索結果) {
      レコード.対象 = false;
    }
    this.$forceUpdate();
  }

  全選択する(): void {
    for (const レコード of this.検索結果) {
      レコード.対象 = true;
    }
    this.$forceUpdate();
  }

  経過措置状態クラス(index: number, 在庫調整: 在庫調整型): string {
    if (this.行が選択されている(index)) {
      return 'selected';
    }
    if (在庫調整.経過措置区分 === '経過措置期間') {
      return '経過措置期間';
    }
    if (在庫調整.経過措置区分 === '経過措置終了') {
      return '経過措置終了';
    }
    return '';
  }

  async 検索する(): Promise<void> {

    if (viewEditingStateModule.画面を編集中である) {
      this.$modal.show('編集中検索確認ダイアログ');
      return;
    }

    await progress(this.検索処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  async 検索処理(): Promise<void> {
    this.アラートメッセージ = [];
    this.検索結果 = [];
    this.選択行番号 = null;

    await api.在庫調整一覧を取得する(this.検索条件)
      .then((response: 在庫調整検索結果型) => {
        if (response.在庫調整検索結果一覧.length === 0) {
          this.showAlert('検索結果が0件です。');
          return;
        }
        this.検索結果に対応する検索条件 = {...this.検索条件};
        this.検索結果 = response.在庫調整検索結果一覧;
        this.検索結果.forEach((在庫調整) => {
            this.$set(在庫調整, '対象', true);
            this.$set(在庫調整, '調整後管理外', 在庫調整.採用品管理対象外フラグ !== '対象外');
        });
        if (response.アラートメッセージ) {
          this.showAlert(response.アラートメッセージ);
        }
      })
      .catch((error: any) => {
        this.showAlert(error.data.message);
      });
  }

  編集中検索確認ダイアログを閉じる() {
    this.$modal.hide('編集中検索確認ダイアログ');
  }

  確定対象が存在する(): boolean {
    const 対象在庫調整一覧 = this.検索結果.filter((在庫調整) => {
      return 在庫調整.対象;
    });
    return 対象在庫調整一覧.length > 0;
  }

  async 確定する(): Promise<void> {
    if (!this.確定対象が存在する()) {
      this.showAlert('在庫調整の確定対象が存在しません');
      return;
    }

    await progress(this.確定処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  キャンセルする(): void {
    this.確定ダイアログを閉じる();
  }

  async 確定処理(): Promise<void> {
    this.アラートメッセージ = [];
    const 在庫調整依頼: 在庫調整登録依頼型 = {
      在庫調整登録依頼一覧: [],
    };

    在庫調整依頼.在庫調整登録依頼一覧 = this.検索結果
      .filter((在庫調整) => 在庫調整.対象)
      .map((在庫調整) => to在庫調整依頼内容型(在庫調整));

    await api.在庫調整を登録する(在庫調整依頼)
      .then(() => {
        this.検索結果に対応する検索条件 = null;
        this.検索結果 = [];
        this.選択行番号 = null;
        this.アラートメッセージ = null;
      })
      .catch((error: any) => {
        if (error.data.errors) {
          this.showAlert(error.data.errors);
          return;
        }
        if (error.data.message && !error.data.errors) {
          this.showAlert([error.data.message]);
        }
      });
  }

  async reload(): Promise<void> {
    if (this.検索結果に対応する検索条件 === null) return;
    this.検索条件 = this.検索結果に対応する検索条件;
    await api.在庫調整一覧を取得する(this.検索結果に対応する検索条件)
      .then((response: 在庫調整検索結果型) => {
        this.検索結果 = response.在庫調整検索結果一覧;
      });
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('在庫調整アラート');
  }

}
